import { Component, Input } from '@angular/core';
import { PopoverInput } from '../base/popover-input';

import { ContactService } from '../../../_services';
import { IContact } from '../../../_entities';

@Component({
	selector: 'popover-contact-dropdown',
	template: require('./popover-contact-dropdown.component.html')
})
export class PopoverContactDropdownComponent extends PopoverInput {

	@Input() emptyText: string = "(Not set)";

	@Input() supplierId: number;

	private contacts: IContact[] = null;

	addNewItem: IContact = <IContact>{ id: 0, firstname: "Add new...", lastname: "" };

	newContact: string;

	validationMsg: string;

	constructor(private service: ContactService) {
		super();
		service.getItems().then(result => this.contacts = result);
	}

	async onShow() {

	}

	async onPreSave($event) {

		this.validationMsg = "";

		//add new item before saving
		if (this.dirtyValue === 0 && !!this.newContact) {
			
			const createdContact = await this.service.addItem({ name: this.newContact, supplierId: this.supplierId });

			this.contacts.push(<IContact>createdContact);
			this.dirtyValue = createdContact.id;

			this.onSave($event);
			this.newContact = "";
		} else if (this.dirtyValue !== 0) {
			this.onSave($event);
		} else {
			$event.reject();
			this.validationMsg = "Please enter contact name";
		}
	}

	get displayText() {

		if (this.contacts) {
			const item = this.items.find(r => r.id === this.originalValue);

			if (item) {
				return `${item.firstname} ${item.lastname}`;
			}

			if (this.originalValue && item == null)
				return "!! " + this.dirtyValue;
		}

		return "";
	}

	get items(): IContact[] {

		if (this.contacts) {
			return this.contacts.filter(x => x.supplierId === this.supplierId);
		}

		return null;
	}

	get selectedItem() : IContact {

		if (this.items) {
			return this.items.concat([this.addNewItem]).find(r => r.id === this.dirtyValue);
		}

		return null;
	}

	set selectedItem(val: IContact) { this.dirtyValue = val.id; }


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/specialized/popover-contact-dropdown.component.ts